import { ROUTE_API } from "constant";
import {
  ESourceTagRelation,
  IBaseDataOutputModel,
  ICreateTagOutputModel,
  IDeleteTagInputputModel,
  IUpdateTagOutputModel,
  TTagOutputModel,
} from "interfaces";
import apiV3 from "utils/api.v3";

export const TagService = {
  getListTag,
  createTag,
  updateTag,
  deleteTag,
};

function getListTag(query?: { source: ESourceTagRelation }) {
  return apiV3.get<IBaseDataOutputModel<TTagOutputModel[]>>({
    url: ROUTE_API.TAG_ROUTE.GET_LIST_TAG,
    query: { ...query, isGetAll: true },
  });
}

function createTag(data: ICreateTagOutputModel) {
  return apiV3.post<IBaseDataOutputModel<TTagOutputModel>>({
    url: ROUTE_API.TAG_ROUTE.CREATE_TAG,
    data,
  });
}

function updateTag(tagId: string, data: IUpdateTagOutputModel) {
  return apiV3.put<IBaseDataOutputModel<TTagOutputModel>>({
    url: ROUTE_API.TAG_ROUTE.UPDATE_TAG.replace("{TAG_ID}", tagId),
    data,
  });
}

function deleteTag(tagId: string, data: IDeleteTagInputputModel) {
  return apiV3.delete<IBaseDataOutputModel<TTagOutputModel>>({
    url: ROUTE_API.TAG_ROUTE.DELETE_TAG.replace("{TAG_ID}", tagId),
    data,
  });
}
